$(document).ready(function () {
  const setCookie = (name, value, days = 7, path = '/') => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
  }
  const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=')
      return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '')
  }

  const popup = $('.blog-popup'),
        overlay = $('.blog-popup-overlay'),
        close = $('.blog-popup__close'),
        cookie = getCookie('blogPopup'),
        timeout = (window.location.pathname.includes('blogs')) ? 60000 : 30000;

  if (popup.length && !cookie) {
    setTimeout(function () {
      overlay.fadeIn(200);
      popup.fadeIn(400)
    }, timeout)
  }

  $(overlay).add(close).on('click', function () {
    popup.fadeOut(200);
    overlay.fadeOut(400);
    setCookie('blogPopup', true, 365 );
  });
});